export default __webpack_public_path__ + "static/media/oasisVideo.fdc613af.mp4";